import { render, staticRenderFns } from "./FiltersForm.vue?vue&type=template&id=fc3bf9e8&lang=pug&"
import script from "./FiltersForm.vue?vue&type=script&setup=true&lang=js&"
export * from "./FiltersForm.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./FiltersForm.vue?vue&type=style&index=0&id=fc3bf9e8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports